$(document).ready(function () {
  const LOCAL_STORAGE_KEY = "early_registration_shown";
  const BANNER_ELEMENT = $("#early-reg-banner");
  const FORM_ELEMENT = $("#early-registration-form");
  const BTN_SUBMIT = $("#btn-early-reg-submit");
  const BTN_CLOSE = $("#early-reg-close");

  // Eğer daha önce gösterildiyse/kayıt olunduysa tekrar gösterme
  if (localStorage.getItem(LOCAL_STORAGE_KEY) === "true") {
    return;
  }

  // 10 saniye ile 20 saniye arası rastgele bir gecikme (10000ms - 20000ms)
  const minDelay = 10000;
  const maxDelay = 20000;
  const initialDelay = Math.floor(Math.random() * (maxDelay - minDelay + 1)) + minDelay;

  // Telefon maskesi (eğer plugin varsa çalışır, yoksa düz string kalır)
  if ($.fn.mask) {
    $("#early-reg-phone").mask("0000 000 00 00", { placeholder: "05XX XXX XX XX" });
  }

  // Banner'ı göster
  const showBanner = () => {
    // Zaten kayıt olduysa çıkarma
    if (localStorage.getItem(LOCAL_STORAGE_KEY) === "true") return;

    BANNER_ELEMENT.removeClass("opacity-0 translate-y-10 sm:translate-y-0 sm:translate-x-full pointer-events-none");
  };

  // Banner'ı gizle
  const hideBanner = (permanently = false) => {
    BANNER_ELEMENT.addClass("opacity-0 translate-y-10 sm:translate-y-0 sm:translate-x-full pointer-events-none");
    if (permanently) {
      localStorage.setItem(LOCAL_STORAGE_KEY, "true");
    }
  };

  // Belirlenen rastgele sürede tetikle
  setTimeout(showBanner, initialDelay);

  // Kapama butonuna tıklanınca gizle
  BTN_CLOSE.on("click", function (e) {
    e.preventDefault();
    hideBanner(true);
  });

  // Form gönderimi
  FORM_ELEMENT.on("submit", function (e) {
    e.preventDefault();

    const data = {
      profession: $("#early-reg-profession").val().trim(),
      phone: $("#early-reg-phone").val().trim(),
      email: $("#early-reg-email").val().trim(),
    };

    if (!data.profession || !data.phone || !data.email) {
      Toast.info("Eksik Bilgi", "Lütfen erken kayıt formundaki tüm alanları doldurunuz.");
      return;
    }

    const phoneRegex = /^(05|5)[0-9]{2}\s?[0-9]{3}\s?[0-9]{2}\s?[0-9]{2}$/;
    if (!phoneRegex.test(data.phone.replace(/\s+/g, ""))) {
      Toast.info(
        "Geçersiz Format",
        "Lütfen geçerli bir telefon numarası giriniz (Örn: 05XX XXX XX XX). Sadece rakam kullanılmalıdır.",
      );
      return;
    }

    // Loading aktif
    BTN_SUBMIT.prop("disabled", true).addClass("opacity-70");
    BTN_SUBMIT.find(".submit-text").text("İşleniyor...");
    BTN_SUBMIT.find(".submit-loading").removeClass("hidden").addClass("inline-flex");

    $.ajax({
      url: "/Public/EarlyRegistration",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(data),
      success: function (res) {
        if (res.success) {
          Swal.fire({
            icon: "success",
            title: "Tebrikler!",
            text: res.message || "Erken kayıt talebiniz başarıyla alınmıştır. Gelişmeler için sizinle iletişime geçeceğiz.",
            confirmButtonText: "Tamam",
            timer: 4000,
          });
          FORM_ELEMENT[0].reset();
          hideBanner(true); // Bir daha gösterme
        } else {
          Toast.error("İşlem Başarısız", res.message || "Kaydınız alınırken bir sorun oluştu. Lütfen tekrar deneyin.");
        }
      },
      error: function (xhr) {
        let errorMsg = "Bağlantı kurulurken sistemsel bir sorun oluştu. Lütfen daha sonra tekrar deneyiniz.";
        if (xhr.responseJSON && xhr.responseJSON.message) {
          errorMsg = xhr.responseJSON.message;
        }
        Toast.error("İşlem Başarısız", errorMsg);
      },
      complete: function () {
        // Loading pasif
        BTN_SUBMIT.prop("disabled", false).removeClass("opacity-70");
        BTN_SUBMIT.find(".submit-text").text("Erken Kayıt Ol");
        BTN_SUBMIT.find(".submit-loading").removeClass("inline-flex").addClass("hidden");
      },
    });
  });
});
